import React, { useEffect, useState } from 'react';

const Removed = ({removed}) => {
    const [remove, setRemove] = useState('')
    useEffect(()=>{
        setRemove(removed)
    }, [])
    return (
        <>
            <img src={removed} key={remove} alt="remove"></img>
        </>
    );
};

export default Removed;